import { createSelector } from "@reduxjs/toolkit"
import PropTypes from "prop-types"
import { useCallback, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"

import ChainOption from "areas/product/jewlr/wizard-options/chain-options"
import { addToCart, forcePanelIndex } from "areas/product/store/actions"
import { ButtonWrapper } from "components/HalfModal/hm-styled-components"
import Modal, { closeModal } from "components/modal"
import Button from "components/ui/button"

const createSelectStateProps = (pref) =>
  createSelector(
    [(state) => state.wizard.data, (state) => state.choices],
    (wizardData, choices) => ({
      chainSelectorUI: wizardData?.[pref]?.chain_type_ui ?? false,
      selectedValue: choices?.[pref]?.value ?? "",
      wizardData,
    })
  )

const ChainSizeModal = ({ pref }) => {
  const dispatch = useDispatch()
  const selectStateProps = useMemo(() => createSelectStateProps(pref), [pref])
  const { chainSelectorUI, selectedValue, wizardData } =
    useSelector(selectStateProps)

  const title = wizardData?.[pref]?.heading?.title
    ? `Choose Your ${wizardData[pref].heading.title}`
    : "Choose Your Chain"

  const handleAddToCart = useCallback(
    (e) => {
      if (selectedValue !== "") {
        e.preventDefault()
        dispatch(addToCart())
      }
    },
    [dispatch, selectedValue]
  )

  const handleClose = useCallback(() => {
    dispatch(forcePanelIndex(pref))
    closeModal()
  }, [dispatch, pref])

  return (
    <Modal
      contentClassName="px-16 tablet:px-24"
      height={chainSelectorUI ? "100%" : "fit-content"}
      label={title}
      onClose={handleClose}
      show={`#chain-size${pref === "ch" ? "" : pref.match(/\d+/)[0]}`}
      variant="squircle"
      width="760px"
    >
      <ChainOption inModal pref={pref} />
      <ButtonWrapper className="tablet:mt-20 mt-16">
        <Button
          data-cy="product-wizard-ch-modal-continue"
          disabled={selectedValue === ""}
          onClick={handleAddToCart}
          variant="secondary"
        >
          Continue
        </Button>
      </ButtonWrapper>
    </Modal>
  )
}

ChainSizeModal.propTypes = {
  pref: PropTypes.string,
}

export default ChainSizeModal
